module.exports = __webpack_public_path__ + "static/media/badge3.8d403c94.svg";